<template>
  <div class="modal-invite-email-component" @keyup.stop="keymap">
    <div class="modal-invite-email">
      <div class="modal-invite-email-header">
        <button class="modal-invite-email-back-button" @click="onClose"></button>
        <p class="modal-invite-email-title">{{ $t("invite.kakao.title") }}</p>
      </div>
      <div class="modal-invite-email-body">
        <div class="modal-invite-email-contents-form">
          <p class="modal-invite-email-contents-title">{{ $t("invite.receiver") }}</p>
          <div class="modal-invite-email-input-wrapper">
            <input class="modal-invite-email-input" maxlength="48" v-model="phone" ref="phone" :placeholder="$t('common.phone')" />
            <button class="modal-invite-email-add-button" @click="add">{{ $t("common.add") }}</button>
          </div>
        </div>
        <div class="modal-invite-email-contents-form">
          <p class="modal-invite-email-contents-title">{{ $t("invite.list") }} <span class="modal-invite-email-count">{{ invites.length }}</span></p>
          <div class="modal-invite-email-list-wrapper">
            <perfect-scrollbar>
              <ul class="modal-invite-email-list">
                <li class="modal-invite-email-item" v-for="(user, i) in invites" :key="i">
                  <p class="modal-invite-email-text">{{ user.phone }}</p>
                  <button class="modal-invite-email-remove-button" @click="removeItem(i)"></button>
                </li>
              </ul>
            </perfect-scrollbar>
          </div>
        </div>
        <VButton class="modal-invite-email-send-button" @click="send">{{ $t("invite.send") }}</VButton>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions} from "vuex";
import VButton from "@/components/Common/VButton";

export default {
  name: 'RoomInviteKakao',
  components: {
    VButton
  },
  data() {
    return {
      phone: '',
      invites: [],
    }
  },
  mounted() {
    this.$refs.phone.focus()
  },
  methods: {
    keymap(e) {
      switch (e.keyCode) {
        case 13: // enter
          this.add();
          break
        case 27: // esc
          this.onClose();
          break
      }
    },
    add() {
      if (this.phone.trim() === '') {
        return
      }

      if (this.invites.findIndex(item => item.phone === this.phone) >= 0) {
        this.$alert(this.$t('invite.kakao.exist'))
      } else {
        this.invites.push({phone: this.phone});
        this.phone = ''
      }
    },
    removeItem(idx) {
      this.invites.splice(idx, 1);
    },
    send() {
      if(this.invites.length > 0) {
        this.$alert({
          text: this.$t('invite.complete'),
          onlyOk: true,
          ok: () => {
            this.onClose()
          }
        })
      } else {
        this.$alert(this.$t('invite.empty'));
      }
    },
    onClose() {
      this.$modal('RoomInviteKakao')
    }
  }
}
</script>

<style lang="scss" scoped>
.modal-invite-email-component {
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9999;
}
.modal-invite-email {
  width: 300px;
  border-radius: 10px;
  overflow: hidden;
}
.modal-invite-email-header {
  height: 40px;
  border-bottom: 1px solid #999;
  background-color: #fff;
  display: flex;
  align-items: center;
}
.modal-invite-email-back-button {
  width: 40px;
  height: 100%;
  background: url('~@/assets/images/arrowLineThickLeft_gray.svg') no-repeat center / 14px auto;
  transition: 0.1s ease-out;
  &:hover {
    background: url('~@/assets/images/arrowLineThickLeft.svg') no-repeat center / 14px auto;
  }
}
.modal-invite-email-title {
  font-size: 14px;
}
.modal-invite-email-body {
  padding: 20px;
  background-color: #eee;
}
.modal-invite-email-contents-form {
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px 0;
  &:first-of-type {
    margin-top: 0;
  }
}
.modal-invite-email-contents-title {
  font-size: 13px;
  font-weight: 700;
  color: #666;
  display: flex;
  align-items: center;
}
.modal-invite-email-count {
  font-size: 13px;
  color: #0cf;
  margin-left: 5px;
}
.modal-invite-email-input-wrapper {
  width: 100%;
  display: flex;
  position: relative;
}
.modal-invite-email-input {
  min-width: 0;
  flex: 1;
  border: 1px solid rgba(0, 0, 0, 0.3);
  border-right: none;
  border-radius: 4px 0 0 4px;
  padding: 6px;
}
.modal-invite-email-add-button {
  min-width: 40px;
  border-radius: 0 4px 4px 0;
  padding: 0 16px;
  background-color: #737898;
  font-size: 13px;
  color: #fff;
  transition: 0.1s ease-out;
  &:hover {
    background-color: $mainColor;
  }
}
.modal-invite-email-list-wrapper {
  width: 100%;
  height: 100px;
  border: 1px solid rgba(0, 0, 0, 0.3);
  border-radius: 4px;
  display: flex;
  overflow: auto;
}
.modal-invite-email-list {
  height: 100%;
  background-color: #fff;
}
.modal-invite-email-item {
  height: 36px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
  background-color: #f4f4f4;
  display: flex;
  align-items: center;
  &:nth-of-type(2n) {
    background-color: #e4e4e4;
  }
}
.modal-invite-email-text {
  min-width: 0;
  flex: 1;
  padding: 0 12px;
  font-size: 12px;
  color: #666;
  text-align: left;
  line-height: 1.4;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.modal-invite-email-remove-button {
  width: 30px;
  height: 100%;
  background: url('~@/assets/images/trash.svg') no-repeat center / 14px auto;
  &:hover {
    background: #f05 url('~@/assets/images/trash_white.svg') no-repeat center / 14px auto;
  }
}
.modal-invite-email-send-button {
  margin-top: 20px;
}
</style>